export default "__VITE_ASSET__h7KOeT_I__";